'use client';

import { Box } from '@mui/material';

type Props = {
  error?: string;
  suggestion: string | null;
  onApply: () => void;
};

/** Soft typo offer — clickable correction, not a blocking error. */
export function IntakeEmailHelperText({ error, suggestion, onApply }: Props) {
  if (error) return <>{error}</>;
  if (!suggestion) return null;
  return (
    <>
      Did you mean{' '}
      <Box
        component="button"
        type="button"
        onClick={onApply}
        sx={{
          p: 0,
          border: 0,
          bgcolor: 'transparent',
          color: 'primary.main',
          textDecoration: 'underline',
          cursor: 'pointer',
          font: 'inherit',
        }}
      >
        {suggestion}
      </Box>
      ?
    </>
  );
}
